<template>
  <div>
    <div class="centBox">
      <!-- 按钮 -->
      <el-scrollbar class="scrollCont">
        <div class="tableCont">
          <el-table
            v-loading="table.loading"
            :pageSize="table.pageSize || 'medium'"
            @selection-change="tableChange"
            :empty-text="table.empty"
            element-loading-background="rgba(0, 0, 0, 0)"
            :header-cell-style="{
              background: '#f2f2f2',
              color: '#000',
              height: '40px',
            }"
            :data="table.tableData"
            style="width: 100%"
          >
            <!-- 多选 -->
            <el-table-column
              v-if="table.selection"
              align="center"
              type="selection"
              width="55"
            ></el-table-column>

            <el-table-column
              label="序号"
              type="index"
              width="55"
              align="center"
            >
            </el-table-column>
            <template v-for="(col, i) in table.tableLabel">
              <template v-if="col.visible || true">
                <el-table-column
                  :key="i"
                  :type="col.type"
                  :fixed="col.fixed"
                  :label="col.title"
                  :min-width="col.width"
                  :sortable="col.sort"
                  :formatter="col.formatter"
                  :align="col.align || 'center'"
                  :show-overflow-tooltip="col.tooltip == false ? false : true"
                  :prop="col.prop"
                  v-bind="col.props"
                  v-if="col.isShow ? col.isShow() : true"
                >
                  <template slot-scope="scope">
                    <slot :name="col.prop" :index="scope.$index">
                      <render-content
                        v-if="col.formatter"
                        :prop="col.prop"
                        :formatter="col.formatter"
                        :data="scope.row"
                      ></render-content>
                      <template v-else-if="col.image">
                        <el-image
                          v-for="(item, index) in textName(
                            scope.row,
                            col.prop,
                            col.types,
                            col.tag
                          )"
                          :key="index + 'k'"
                          style="width: 80px; height: 80px"
                          :src="item"
                          :preview-src-list="
                            textName(scope.row, col.prop, col.types, col.tag)
                          "
                        ></el-image>
                      </template>
                      <span
                        @click="hanleTextFn(scope, col.isTableShow)"
                        :style="{
                          color: col.color ? col.color : '',
                          cursor: col.isTableShow ? 'pointer' : '',
                        }"
                        :class="col.color ? 'point' : ''"
                        v-else
                      >
                        {{
                          textName(scope.row, col.prop, col.types, col.tag) ||
                          "-"
                        }}
                      </span>
                    </slot>
                  </template>
                </el-table-column>
              </template>
            </template>

            <el-table-column
              v-if="table.tableOption"
              fixed="right"
              align="center"
              header-align="center"
              :label="table.tableOption.title"
              :width="table.tableOption.width"
            >
              <template slot-scope="scope">
                <template
                  v-for="(btn, j) in table.tableOption.buttons ||
                  tableChildFunction"
                >
                  <template v-if="btn.methods != 'delete'">
                    <el-button
                      :key="j"
                      v-if="btn.showIf ? btn.showIf(scope.row, btn) : true"
                      @click="clickBtn(scope.row, btn.methods || btn.address)"
                      pageSize="mini"
                      :type="btn.type || 'text'"
                      v-bind="btn.props"
                      v-on="btn.listeners"
                      >{{ btn.label || btn.name }}</el-button
                    >
                  </template>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagin_l" v-if="!table.pageShow">
            <el-pagination
              @pageSize-change="pageSizeChange"
              @current-change="pageCurrentChange"
              background
              :current-pageNumber="paramsInfos.pageNumber"
              :pageNumber-sizes="[10, 15, 20, 30]"
              :pageNumber-pageSize="paramsInfos.pagesize || 1"
              :prev-text="table.prevText || '上一页'"
              :next-text="table.nextText || '下一页'"
              layout="total, prev, pager, next, jumper, slot, sizes"
              :total="table.total || 0"
            >
              <button class="page_btn" v-text="'确定'"></button>
            </el-pagination>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
const RenderContent = {
  props: {
    render: Function,
    formatter: Function, // 格式化数据
    data: Object,
    prop: String,
    listeners: Function,
    tag: Object,
  },
  render(h) {
    if (this.render) {
      return this.render(h, this.data, this.listeners);
    }
    if (this.tag) return this.tag;
    let value = this.data[this.prop];
    if (this.formatter) {
      value = this.formatter(value, this.data);
    }
    return <span>{value}</span>;
  },
};

export default {
  components: {
    RenderContent,
  },
  name: "TableModule",
  props: {
    tableJson: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 携带的参数信息
    paramsInfo: {
      type: Object,
      default: () => {
        return {
          pageSize: 10,
          pageNumber: 1,
        };
      },
    },
  },
  data() {
    return {
      idJson: {},
      ids: "",
      tableChildFunction: [],
      topChildFunction: [],
      allColumnsSelectedIndeterminate: false,
      allColumnsSelected: true,
      options: [
        {
          value: 10,
          label: 10,
        },
        {
          value: 15,
          label: 15,
        },
        {
          value: 20,
          label: 20,
        },
      ],
    };
  },
  computed: {
    table: {
      get() {
        return this.tableJson;
      },
      set(val) {
        this.$emit("update:tableJson", val);
      },
    },
    paramsInfos: {
      get() {
        return this.paramsInfo;
      },
      set(val) {
        this.$emit("update:paramsInfo", val);
      },
    },
  },
  methods: {
    //分页数量发生变化时触发
    pageSizeChange(val) {
      this.paramsInfos.pageSize = val;
      this.$emit("search", this.paramsInfos);
    },
    //分页页码发生变化时触发
    pageCurrentChange(val) {
      this.paramsInfos.pageNumber = val;
      this.$emit("search", this.paramsInfos);
    },
    //表格选中触发方法
    tableChange(arr) {
      var ids = [];
      arr.map((item) => {
        ids.push({
          id: item.id,
          pkId: item.pkId,
          item,
        });
      });
      this.table.ids = ids;
    },
    //点击列表按钮触发
    clickBtn(row, methods) {
      this.$emit("btn", methods, row);
    },
    /**
     * row: 表格信息
     * isTableShow  是否打开表格点击事件
     */
    hanleTextFn(row, isTableShow) {
      if (isTableShow) {
        this.$emit("onTable", row);
      }
    },
    textName(data, propName, types, tag) {
      let prop = propName.split(".");
      let text;
      try {
        prop.forEach((item, i) => {
          if (i < prop.length - 1) {
            data = data[item];

            if (!data) throw Error();
          } else {
            text = data[item];
          }
        });
      } catch (e) {}

      if (types != undefined || tag != undefined)
        return this.textCont(text, types, tag, prop);
      return text;
    },
    textCont(text, types, tag, prop) {
      var tagText = text;
      var icon = <span />;
      return tagText;
    },
  },
};
</script>

<style scoped lang="scss">
// .centBox {
//   margin: 10px;
// }
.el-scrollbar__wrap {
  overflow: auto;
  padding: 15px;
}
.content-search {
  font-pagesize: 18px;
  // border-bottom: 1px solid #e6e6e6;
  position: relative;
  line-height: 24px;
  margin-left: 15px;
  margin-right: 15px;
  padding: 20px 20px 0 20px;
  min-height: 75px;
  background: #fff;
  font: 18px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  .sLine {
    font: icon;
    margin-left: 5px;
  }
  .blue-line {
    display: inline-block;
    width: 4px;
    border-radius: 30%;
    height: 20px;
    background: #228fec;
    vertical-align: top;
    margin-right: 10px;
  }
  .clearfix span {
    line-height: 20px;
  }
}
.scrollCont {
  height: calc(100% - 75px);
  width: 100%;
}
.tableCont {
  background: #fff;
  // padding: 0px 20px 20px;
}
::v-deep .el-pagination {
  margin-top: 30px;
  float: right;
}
.point {
  cursor: pointer;
}

.crud-opt {
  display: flex;
  align-items: center;
  // height: 50px;
  padding: 0 20px;
  background-color: #ffffff;
}
.crud-opt .crud-opts-right {
  margin-left: auto;
  margin-bottom: 10px;
}
::v-deep .warning-row {
  background: #e0e0e0 !important;
  cursor: not-allowed !important;
  position: relative;
}

::v-deep .warning-row::after {
  content: "";
  width: 100%;
  height: 2px;
  background: #333333;
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 999;
}
.footer {
  // margin-top: 14px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  .foot_left {
    font-pagesize: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    padding-top: 28px;
  }
  .s_pt {
    width: 65px;
  }
}
</style>
